import { Component, OnInit } from '@angular/core';
import { BaryModalEvent } from '../../../../models/bary-modal-event';
import { patchObject } from '../../../shared/util/object-util';
import { FormBuilder } from '@angular/forms';
import { BaryModalForm } from '../../../../models/bary-modal-form';
import { TranslateService } from '@ngx-translate/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FaqItemControls } from '../../../../models/forms/builder/FaqItemFormBuilder';
import { BaryFormFactoryService } from '../../../../services/bary-form-factory.service';

@Component({
  selector: 'jhi-bary-modal-add-question-answer.component',
  templateUrl: './bary-modal-add-question-answer.component.html',
  styleUrls: ['./bary-modal-add-question-answer.component.scss'],
})
export class BaryModalAddQuestionAnswerComponent extends BaryModalForm implements OnInit {
  override model: { question: string; answer: string } = { question: '', answer: '' };
  controls: FaqItemControls;
  isUpdate: boolean = false;

  constructor(private fb: FormBuilder, public bff: BaryFormFactoryService, public translateService: TranslateService, public modalRef: MDBModalRef) {
    super();
    this.controls = this.bff.makeFaqItemControls(this.model);
  }

  ngOnInit(): void {
    this.controls = this.bff.makeFaqItemControls(this.model);
    this.modalForm = this.fb.group(this.controls, { validators: [] });
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      patchObject(this.model, this.modalForm.value);
      this.action.next(new BaryModalEvent({ submit: true, value: this.model }));
      this.modalRef.hide();
    }
  }

  setButtonLabel(): string {
    return this.translateService.instant(this.isUpdate ? 'modals.addQuestionAnswer.update.buttons.submit' : 'modals.addQuestionAnswer.buttons.submit') as string;
  }
}
